import { CalendarDays, MapPin } from "lucide-react";
import { formatEventDate, splitEvents } from "../lib/events";

function EventCard({ event, past }) {
  return (
    <article
      data-testid={`event-card-${event.id}`}
      className={`rounded-3xl border p-6 md:p-7 h-full flex flex-col ${
        past
          ? "bg-white border-black/8 text-black/70"
          : "bg-[#FDF2F8] border-black/5 shadow-ambient"
      }`}
    >
      <p className={`font-mono text-[11px] uppercase tracking-[0.2em] inline-flex items-center gap-2 ${past ? "text-black/40" : "text-[#EC4899]"}`}>
        <CalendarDays size={14} />
        {formatEventDate(event.date)}
      </p>
      <h3 className={`font-display text-2xl md:text-[1.75rem] mt-3 leading-tight ${past ? "text-black/70" : "text-black"}`}>
        {event.title}
      </h3>
      {event.text ? (
        <p className="mt-3 text-[15px] leading-relaxed text-black/65 flex-1">{event.text}</p>
      ) : (
        <div className="flex-1" />
      )}
      {event.location ? (
        <p className="mt-4 text-sm text-black/50 inline-flex items-center gap-2">
          <MapPin size={14} />
          {event.location}
        </p>
      ) : null}
    </article>
  );
}

function EventGrid({ events, past, empty }) {
  if (!events.length) {
    return <p className="text-black/50">{empty}</p>;
  }
  return (
    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
      {events.map((event) => (
        <EventCard key={event.id} event={event} past={past} />
      ))}
    </div>
  );
}

export function EventsSection({ events }) {
  const { upcoming, past } = splitEvents(events);

  return (
    <>
      <section id="events" data-testid="upcoming-events" className="py-20 md:py-24 bg-[#FDF2F8]">
        <div className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-14">
          <p className="font-mono uppercase text-xs tracking-[0.25em] text-[#EC4899]">Diary</p>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-black mt-4 leading-[0.95]">Any other events/Upcoming workshops</h2>
          <p className="mt-4 max-w-2xl text-black/65 text-lg">
            Courses and workshops coming up. 
          </p>
          <div className="mt-10">
            <EventGrid events={upcoming} empty="No upcoming events just now. Check back soon." />
          </div>
        </div>
      </section>

      {past.length > 0 && (
        <section id="past-events" data-testid="past-events" className="py-20 md:py-24">
          <div className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-14">
            <p className="font-mono uppercase text-xs tracking-[0.25em] text-[#EC4899]">Archive</p>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-black mt-4 leading-[0.95]">Past events</h2>
            <p className="mt-4 max-w-2xl text-black/65 text-lg">
              Workshops and courses that have already taken place.
            </p>
            <div className="mt-10">
              <EventGrid events={past} past />
            </div>
          </div>
        </section>
      )}
    </>
  );
}
